module.exports = __webpack_public_path__ + "area_jiangzhe_dark.53020599.png";